const persistedSchool = JSON.parse(
  localStorage.getItem('demoStudentSchool') || '{}',
);
const persistedGrade = localStorage.getItem('demoStudentGrade');
const persistedSkipOnboarding = localStorage.getItem(
  'demoStudentSkipOnboarding',
);
const persistedFirstName = localStorage.getItem('demoStudentFirstName');
const persistedLastName = localStorage.getItem('demoStudentLastName');
const localStorageFieldMapping = {
  school: 'demoStudentSchool',
  grade: 'demoStudentGrade',
  firstName: 'demoStudentFirstName',
  lastName: 'demoStudentLastName',
  skipOnboarding: 'demoStudentSkipOnboarding',
};

export default function internalHelper(
  state = {
    schools: [],
    grades: [],
    studentInfo: {
      school: persistedSchool,
      grade: persistedGrade ? +persistedGrade : undefined,
      skipOnboarding: persistedSkipOnboarding === 'true',
      firstName: persistedFirstName,
      lastName: persistedLastName,
    },
  },
  action,
) {
  switch (action.type) {
    case 'STUDENT_DEMO_ACCOUNT.POPULATE_CONTEXT':
      return {
        ...state,
        ...action.data,
      };
    case 'STUDENT_DEMO_ACCOUNT.POPULATE_STUDENT_INFO':
      return {
        ...state,
        studentInfo: {
          ...state.studentInfo,
          ...action.data,
        },
      };
    case 'STUDENT_DEMO_ACCOUNT.UPDATE_STUDENT_INFO':
      if (localStorageFieldMapping[action.field]) {
        if (typeof action.value === 'object') {
          localStorage.setItem(
            localStorageFieldMapping[action.field],
            JSON.stringify(action.value || {}),
          );
        } else {
          localStorage.setItem(
            localStorageFieldMapping[action.field],
            action.value,
          );
        }
      }
      return {
        ...state,
        studentInfo: {
          ...state.studentInfo,
          [action.field]: action.value,
        },
      };
    default:
      return state;
  }
}
